module.exports = __webpack_public_path__ + "static/media/favourite.d88db0fb.png";